export const checkLetterOnly = event => {
  const allowedKeys = [
    8, // Backspace
    9, // Tab
    46, // Delete
    37, // Left arrow
    38, // Up arrow
    39, // Right arrow
    40 // Down arrow
  ];

  const key = event.keyCode || event.which;
  let isAllowed = allowedKeys.includes(key);

  if (!isAllowed) {
    // a-z, A-Z
    if (key >= 65 && key <= 90) {
      isAllowed = true;
    }
  }

  if (!isAllowed) {
    event.preventDefault();
  }
};

export const checkNumberOnly = event => {
  const allowedKeys = [
    8, // Backspace
    9, // Tab
    46, // Delete
    37, // Left arrow
    38, // Up arrow
    39, // Right arrow
    40, // Down arrow
    67, // Copy
    86 // Paste
  ];

  const key = event.keyCode || event.which;
  let isAllowed = allowedKeys.includes(key);

  if (!isAllowed) {
    // 0-9
    if (key >= 48 && key <= 57) {
      isAllowed = true;
    }
  }

  if (!isAllowed) {
    event.preventDefault();
  }
};
